module.exports = __webpack_public_path__ + "img/Graph1_7days_red.49b5fe55.png";